import { Group, Text, Menu, Button, useMantineColorScheme } from "@mantine/core";
import { Database, ChevronDown } from "lucide-react";

interface ReportDataToolbarProps {
    rowCount: number;
    rowsCount: number;
    isExporting: boolean;
    onExport: (type: 'csv' | 'xlsx' | 'json', all: boolean) => void;
    hideExport?: boolean;
}

export function ReportDataToolbar({
    rowCount,
    rowsCount,
    isExporting,
    onExport,
    hideExport
}: ReportDataToolbarProps) {
    const { colorScheme } = useMantineColorScheme();
    return (
        <Group justify="space-between" gap="sm">
            <Group gap={6}>
                <Database size={14} color={colorScheme === 'dark' ? 'var(--mantine-color-dimmed)' : 'var(--mantine-color-gray-6)'} />
                <Text size="xs" fw={500} c={colorScheme === 'dark' ? 'dimmed' : 'gray.7'}>{rowCount} records found</Text>
            </Group>
            {!hideExport && (
                <Group gap="xs">
                    <Menu shadow="md" width={220}>
                        <Menu.Target>
                            <Button
                                variant="light"
                                color="gray"
                                size="xs"
                                leftSection={<ChevronDown size={14} />}
                            >
                                Export Data
                            </Button>
                        </Menu.Target>
                        <Menu.Dropdown
                            style={{
                                backgroundColor: colorScheme === 'dark' ? 'var(--modal-bg)' : undefined,
                                borderColor: colorScheme === 'dark' ? 'var(--modal-border)' : undefined,
                                backdropFilter: 'blur(var(--modal-blur))'
                            }}
                        >
                            <Menu.Label>Export Page ({rowsCount} rows)</Menu.Label>
                            <Menu.Item onClick={() => onExport('csv', false)}>Export to CSV</Menu.Item>
                            <Menu.Item onClick={() => onExport('xlsx', false)}>Export to Excel</Menu.Item>
                            <Menu.Item onClick={() => onExport('json', false)}>Export to JSON</Menu.Item>
                            <Menu.Divider />
                            <Menu.Label>Export All ({rowCount} rows)</Menu.Label>
                            <Menu.Item onClick={() => onExport('csv', true)} disabled={isExporting}>Export All to CSV</Menu.Item>
                            <Menu.Item onClick={() => onExport('xlsx', true)} disabled={isExporting}>Export All to Excel</Menu.Item>
                            <Menu.Item onClick={() => onExport('json', true)} disabled={isExporting}>Export All to JSON</Menu.Item>
                        </Menu.Dropdown>
                    </Menu>
                </Group>
            )}
        </Group>
    );
}
